import {EntrySingletonPageShared} from './../../EntrySingletonPageShared.ts'
import '../../css/style.scss'
import {UIWStoreController} from './UIWStoreController.ts'
import {UIWHeaderController} from '../ui_html/header/UIWHeaderController.ts'
import {UISidebarController} from '../ui_html/sidebar/UISidebarController.ts'
import {EntryShared} from '../../../shared/scripts/EntryShared.ts'
import {UISingletonScrollController} from '../../../shared/scripts/ui_scroll_controller/UISingletonScrollController.ts'

class EntryStore extends EntryShared {
    constructor() {
        super()
        void EntryStore.init()
    }

    private static async init() {
        EntryShared.initializeAudio()

        await EntryShared.initializeEntry()

        const headerController = new UIWHeaderController()
        new UISidebarController()

        new UIWStoreController()
        new UISingletonScrollController()

        EntrySingletonPageShared.initializeSocketAndGeneralServices(headerController)
    }
}

new EntryStore()
